import React from 'react';
import { IconButton } from '@material-ui/core';
import { Pencil, Trash } from 'tabler-icons-react';
import { useShifts } from './ShiftsContext.jsx';
import '../../styles/turnos.css';

function formatTime(timeStr) {
    if (!timeStr) return '--:--';
    const t = timeStr.includes('T') ? timeStr.split('T')[1] : timeStr;
    const [hh, mm] = t.split(':');
    const h = parseInt(hh, 10);
    const period = h < 12 ? 'AM' : 'PM';
    const h12 = h === 0 ? 12 : h > 12 ? h - 12 : h;
    return `${h12}:${mm} ${period}`;
}

function isMidnightCross(timeStr) {
    if (!timeStr || !timeStr.includes('1900-01-02')) return false;
    const t = timeStr.split('T')[1] || '';
    return !t.startsWith('00:00');
}

function Horario({ schedule, index }) {
    const { setEditingSchedule, setDialogEditSchedule, setDeletingSchedule, setDialogDeleteSchedule } = useShifts();

    const handleEdit = () => {
        setEditingSchedule(schedule);
        setDialogEditSchedule(true);
    };

    const handleDelete = () => {
        setDeletingSchedule(schedule);
        setDialogDeleteSchedule(true);
    };

    const finLabel = formatTime(schedule.fin);
    const crossesMidnight = isMidnightCross(schedule.fin);

    return (
        <div className="turnos-schedule-card">
            <div className="turnos-schedule-card-header">
                <h3 className="turnos-schedule-title">Horario {index + 1}</h3>
                <div className="turnos-schedule-header-actions">
                    <IconButton size="small" className="turnos-schedule-edit-btn" onClick={handleEdit}>
                        <Pencil size={13} strokeWidth={1.75} />
                    </IconButton>
                    <IconButton size="small" className="turnos-schedule-delete-btn" onClick={handleDelete}>
                        <Trash size={13} strokeWidth={1.75} />
                    </IconButton>
                </div>
            </div>

            <div className="turnos-schedule-time-range">
                <div className="turnos-schedule-time-block">
                    <span className="turnos-time-label">Inicio</span>
                    <span className="turnos-schedule-time-value">{formatTime(schedule.inicio)}</span>
                </div>
                <div className="turnos-schedule-time-separator">→</div>
                <div className="turnos-schedule-time-block">
                    <span className="turnos-time-label">Fin</span>
                    <span className="turnos-schedule-time-value">
                        {finLabel}
                        {crossesMidnight && <span className="turnos-midnight-badge">+1</span>}
                    </span>
                </div>
            </div>
        </div>
    );
}

export default Horario;
